var _desc, _defs, _rect, _path, _path2, _path3, _rect2, _path4, _path5, _circle, _circle2, _circle3, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductStorefrontChips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Chips") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A red and orange snack chips bag product illustration.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bag-body",
    x1: 70,
    y1: 36,
    x2: 170,
    y2: 214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a33c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#b23212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91011e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    rx: 24,
    fill: "#fff7f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 38c25 11 67 11 92 0l-8 166c-24 14-52 14-76 0L74 38Z",
    fill: "url(#bag-body)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74 38c25 11 67 11 92 0l-4 28c-24 9-60 9-84 0L74 38Z",
    fill: "#7b0018",
    opacity: 0.22
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 204c24 14 52 14 76 0l-2 21c-24 10-48 10-72 0l-2-21Z",
    fill: "#6f0017"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 83,
    width: 66,
    height: 52,
    rx: 12,
    fill: "#ffffff",
    opacity: 0.94
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99 112c5-10 14-16 25-16 8 0 15 3 20 9",
    fill: "none",
    stroke: "#b23212",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99 123h43",
    fill: "none",
    stroke: "#91011e",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 156,
    r: 12,
    fill: "#ffd166"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 164,
    r: 14,
    fill: "#f4c145"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 181,
    r: 11,
    fill: "#ffd166"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91 54c17 6 41 7 58 0",
    fill: "none",
    stroke: "#fff7f5",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStorefrontChips);
export default __webpack_public_path__ + "static/media/product_storefront_chips.b9b46cd2717ab4263029dd117e6ec525.svg";
export { ForwardRef as ReactComponent };